"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorRemoveEmojiIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5.842 8.67a7 7 0 0 0 9.487 9.488l-1.12-1.121A5.5 5.5 0 0 1 12 17.5 5.506 5.506 0 0 1 6.5 12a5.5 5.5 0 0 1 .464-2.207zm11.195 5.539A5.5 5.5 0 0 0 17.5 12c0-3.033-2.467-5.5-5.5-5.5a5.5 5.5 0 0 0-2.207.464L8.67 5.842a7 7 0 0 1 9.487 9.487z" clip-rule="evenodd"/><rect width="1.75" height="19.976" x="4.319" y="5.556" fill="currentcolor" rx=".875" transform="rotate(-45 4.319 5.556)"/></svg>`
}, props));
EditorRemoveEmojiIcon.displayName = 'EditorRemoveEmojiIcon';
var _default = exports.default = EditorRemoveEmojiIcon;